// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    domain: "http://dev.renewbuy.com",
    api: "/api/v1/",
    apiv2: "/api/v2/life_v2/proposal/",
    appId: "7b574be9-96c2-4afc-934e-a333f9d27e94",
    apiSecretKey: "YiBYbVTAOIT6TD2k8L3S22pou4IVBdR6",
    defaultLanguage: "en",
    amsURL: "http://accounts.rbstaging.in/",
    appInitializer: {

        "productModuleName": {
            "renewbuy-backend-header": {

                "api-secret-key": "YiBYbVTAOIT6TD2k8L3S22pou4IVBdR6",
                "app-id": "7b574be9-96c2-4afc-934e-a333f9d27e94"

            }
        }
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
